import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PageContainerComponent } from '../../layout/page-container/page-container.component';
import { LAYOUT_TYPE, ScreenNames } from '../../model/common.model';
import { TabConfig } from '../../model/form.model';
import { getSurveyTabConfig } from '../../model/survey.model';

@Component({ selector: 'app-survey', standalone: true, imports: [PageContainerComponent], templateUrl: './survey.component.html', styleUrls: ['./survey.component.scss'] })
export class SurveyComponent {
  @Input() backFuncCall?: () => void;
  private readonly router = inject(Router);
  readonly LayoutType: typeof LAYOUT_TYPE = LAYOUT_TYPE;
  readonly title = 'PAS - Pre Attendance Survey';
  readonly tabConfig: TabConfig[] = getSurveyTabConfig();
  readonly breadcrumbProps = {
    subtitle: 'Review attendee responses, dietary requirements and question response rates',
    backClicked: () => this.backFuncCall ? this.backFuncCall() : this.router.navigate([`/${ScreenNames['pasDashboard']}`])
  };
}
